import React, { useEffect, useState } from 'react';
import PageTitleBanner from './Common/PageTitleBanner';
import { useNavigate } from 'react-router-dom';

const Gallery = () => {

  const baseUrl = process.env.REACT_APP_BASE_URL || '/';
  const [data, setData] = useState([])
  const [mainData, setMainData] = useState([])
  const [pageIndex, setpageIndex] = useState(0)

  const navigate = useNavigate();
  const photoUrl = process.env.REACT_APP_Photo_URL;

  useEffect(() => {
    GetGalleryData();
  }, []);

  const GetGalleryData = async () => {
    try {
      const res = await fetch(`${baseUrl}Photo/GetPhoto`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          TitleID: '',
          Title: '',
          TypeID: '',
          Type: 'Gallery',
          PaginationID: '-1',
          PageLength: '',
        }),
      });

      const result = await res.json()
      console.log(result, "result")
      const tempt = result.data.slice(0, 8)
      setData(tempt)
      setMainData(result.data)

      // const result = await res.json();
      // if (result.status === 1) {
      //   setData(result.data);
      // } else {
      //   console.error(result.message);
      // }
    } catch (error) {
      console.error('Error fetching gallery data:', error);
    }
  };
  const handleImageClick = (e) => {
    debugger;
    navigate("/GalleryDetail", {
      state: e
    });
  };

  const handleNextData = (id) => {

    if ((id) * 8 >= mainData.length) {
      return
    }
    let tempt = [...mainData]
    let slicedArray = tempt.slice(id * 8, id * 8 + 8)

    setData(slicedArray)
    setpageIndex(prev => prev + 1)

  }
  const handlepreviousData = (id) => {
    if (id == -1) {
      return
    }

    let tempt = [...mainData]
    let slicedArray = tempt.slice(id * 8, id * 8 + 8)
    setData(slicedArray)
    setpageIndex(prev => prev - 1)

  }


  return (
    <>
      <PageTitleBanner title={'Gallery'} />
      <div id="content" className="site-content">
        <div className="faq-top secpadd" >
          <div className="container">
            <div className="fp-testimonials-grid">
              <div className="testi-list row" style={{ marginRight: '5%' }}>
                <div className="col-md-12" style={{ marginLeft: '2%' }}>
                  {data?.map((item, index) => (
                    <div key={index} className="testi-item col-md-3">

                      {item.ImageDetail && item.ImageDetail?.length > 0 ? (
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          <img
                            src={photoUrl + item.ImageDetail[0].Image}
                            alt={`Image 1`}

                            style={{ width: 300, height: 150, marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => handleImageClick(item.TitleID)}
                          />
                        </div>
                      ) : (
                        <div>
                          <img
                            src="Images/Noimage.png"
                            alt="No Image Available"
                            style={{ width: '80px', height: '80px', marginRight: '5px', border: '1px solid black', color: 'black' }}
                          />
                        </div>
                      )}

                      <div className="testi-list row">
                        <h4 style={{ marginLeft: '13%', width: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} >
                          {item.Title}
                        </h4>
                      </div>

                    </div>
                  ))}
                </div>
              </div>

              {data?.length > 0 && (
                <>
                  <button onClick={() => handlepreviousData(pageIndex - 1)} className='fp-btn-2nd readmore' style={{ marginLeft: '2.5%' }} >PREVIOUS</button>
                  <button onClick={() => handleNextData(pageIndex + 1)} style={{ float: "right" }} className='fp-btn-2nd readmore'>NEXT</button>
                </>)}

            </div>
          </div>
        </div>
      </div>
      <br />
    </>
  );
};

export default Gallery;
